import { render, staticRenderFns } from "./JobCardSkeleton.vue?vue&type=template&id=884b7ea2&"
import script from "./JobCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./JobCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports